import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNote2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="note-2"><path d="M20.25 3.75H3.75V20.25H14.5781L20.25 14.5781V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M20 13.75H13.75V20" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconNote2;
